import {
  STATE_FETCH_DATA_SUCCESS,
  STATE_HAVE_ERROR,
  STATE_ARE_LOADING,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Get } from "../../services/api.service";

// Action creator function to handle different types of home primary actions
export function stateListAction(action, payload) {
  switch (action) {
    case STATE_HAVE_ERROR:
      return {
        type: action,
        hasError: payload,
      };

    case STATE_ARE_LOADING:
      return {
        type: action,
        isLoading: payload,
      };

    case STATE_FETCH_DATA_SUCCESS:
      return {
        type: action,
        homePrimary: payload,
      };

    default:
      return;
  }
}

// Async action creator function to fetch home primary data
export function stateListFetchData(ele_id) {
  return (dispatch) => {
    try {
      // Dispatch action indicating data is loading
      dispatch(stateListAction(STATE_ARE_LOADING, true));

      // Check if home primary data is available in local storage
      if (localStorage.getItem("SandeshElectionStates")) {
        // If available, dispatch action with data from local storage
        dispatch(
          stateListAction(
            STATE_FETCH_DATA_SUCCESS,
            JSON.parse(localStorage.getItem("SandeshElectionStates")),
          ),
        );
      }

      // Fetch home primary data using GET request
      return new Promise((resolve, reject) => {
        Get(HttpService.stateList + `?election_id=${ele_id}`).then(
          (result) => {
            // Store fetched data in local storage
            localStorage.setItem("SandeshElectionStates", JSON.stringify(result));
            // Dispatch action with fetched home primary data
            dispatch(stateListAction(STATE_FETCH_DATA_SUCCESS, result));
            resolve(result);
          },
          (error) => {
            reject(error); // Reject promise with error if fetching fails
          },
        );
      });
    } catch (error) {
      // Dispatch action if there's an error in fetching data
      dispatch(stateListAction(STATE_HAVE_ERROR, true));
    }
  };
}
